'use client'

import { keepPreviousData, useInfiniteQuery } from '@tanstack/react-query'

import { supportQueries } from '@/entities/support'
import { UserType } from '@/entities/user'

type Props = {
  userType: UserType
}

export const useNoticesInfinite = ({ userType }: Props) => {
  const { data, hasNextPage, fetchNextPage } = useInfiniteQuery({
    ...supportQueries.noticesInfinite(userType),
    placeholderData: keepPreviousData,
  })

  const notices = data?.pages.flatMap(page => page.content) ?? []

  return {
    notices,
    hasNextPage,
    fetchNextPage,
  }
}
